import MainBackground from "../Backgrounds/MainBackground";

const MainSection: React.FC = () => {
    return (
        <MainBackground/>
    );
}

export default MainSection;
